import { fetch } from '@/utils/fetch';

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryInstagramPoints(instagramId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/instagram-points/list/${instagramId}`,
    method: 'get',
  });
}

/**
 * 根据 id 添加 Point
 * @returns {Promise<Response>}
 */
export function _addInstagramPoints(instagramId, data) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/instagram-points/add/${instagramId}`,
    method: 'post',
    data: data
  });
}

/**
 * 删除 goodsPoint
 * @returns {Promise<Response>}
 */
export function _deleteInstagramPoints(relationId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/instagram-points/delete/${relationId}`,
    method: 'post',
  });
}
